// @ts-ignore
import Quill from '@cimpress-technology/quill/core';
import { FALLBACK_FONT_STRING } from '../../consts';

export const { StyleAttributor, Scope } = Quill.import('parchment');

class FamilyAttributor extends StyleAttributor {
    public converter: (value: any) => string = (value) => value;
    public add(node: HTMLElement, value: string) {
        if (!super.canAdd(node, value)) {
            return false;
        }
        // Store the un-converted, un-quoted value as an HTML data attribute
        // eslint-disable-next-line no-param-reassign
        node.dataset.fontFamily = value;
        const converted = this.converter(value);
        // we need to wrap quotes around fonts because for some odd reason if you have a font that has
        // a number in it (such as Slabo 27px), the browser (at least chrome) refuses to use it unless
        // it has quotes around it.
        const withQuotes = `"${converted}"`;
        // we also add a fallback font to the end of the font-family string so consumers can implement their own fallback font logic in the case that a font (or subset of a font) is not available on their system
        const withFallback = `${withQuotes}, ${FALLBACK_FONT_STRING}`;
        return super.add(node, withFallback);
    }

    // eslint-disable-next-line class-methods-use-this
    public value(node: HTMLElement): string {
        if (!node.dataset.fontFamily) {
            return '';
        }
        // Return the original value stored on the HTML data attribute instead of converting back from the value held in the HTML style attribute
        return node.dataset.fontFamily;
    }
}

// @ts-ignore
export default new FamilyAttributor('fontFamily', 'font-family', { scope: Scope.INLINE, whitelist: null });
// @ts-ignore
export const BlockFamilyAttributor = new FamilyAttributor('blockFontFamily', 'font-family', { scope: Scope.BLOCK });
